import React, { Component } from "react";
import RecurringExpenseService from "../services/recurring-expense.service";
import FamilyService from "../services/family.service";
import AuthService from "../services/auth.service";
import EventBus from "../common/EventBus";
import RecurringExpenseModals from "./recurring-expense-modals.component";

export default class RecurringExpense extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recurringExpenses: [],
      selectedFamily: null,
      familyMembers: [],
      showAddExpenseModal: false,
      showEditExpenseModal: false,
      editingExpense: null,
      showDeleteExpenseModal: false,
      deletingExpense: null,
      newExpense: {
        name: "",
        type: "basic",
        tr: false,
        amount: "",
        location: "",
        owner: "",
      },
      message: "",
    };

    this.handleShowAddExpenseModal = this.handleShowAddExpenseModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleNewExpenseChange = this.handleNewExpenseChange.bind(this);
    this.submitAddExpense = this.submitAddExpense.bind(this);
    this.handleShowEditExpenseModal = this.handleShowEditExpenseModal.bind(this);
    this.handleCloseEditModal = this.handleCloseEditModal.bind(this);
    this.handleEditExpenseChange = this.handleEditExpenseChange.bind(this);
    this.submitEditExpense = this.submitEditExpense.bind(this);
    this.handleShowDeleteExpenseModal = this.handleShowDeleteExpenseModal.bind(this);
    this.handleCloseDeleteModal = this.handleCloseDeleteModal.bind(this);
    this.submitDeleteExpense = this.submitDeleteExpense.bind(this);
  }

  componentDidMount() {
    const currentUser = AuthService.getCurrentUser();
    const selectedFamily = JSON.parse(localStorage.getItem("selectedFamily"));
    
    if (selectedFamily) {
        this.setState({ selectedFamily: selectedFamily });
        this.retrieveRecurringExpenses(selectedFamily.id);
        this.retrieveFamilyMembers(selectedFamily.id);
    } else if (currentUser && currentUser.families && currentUser.families.length > 0) {
      const family = currentUser.families[0];
      localStorage.setItem("selectedFamily", JSON.stringify(family));
      this.setState({ selectedFamily: family });
      this.retrieveRecurringExpenses(family.id);
      this.retrieveFamilyMembers(family.id);
    }
  }

  retrieveFamilyMembers(familyId) {
    FamilyService.getFamilyMembers(familyId)
      .then((response) => {
        this.setState({
          familyMembers: response.data.map(member => ({ id: member._id, username: member.username })),
        });
      })
      .catch((e) => {
        console.log(e);
        if (e.response && e.response.status === 401) {
            EventBus.dispatch("logout");
        }
      });
  }

  retrieveRecurringExpenses(familyId) {
    FamilyService.getRecurringExpensesByFamilyId(familyId)
      .then((response) => {
        this.setState({
          recurringExpenses: response.data,
        });
      })
      .catch((e) => {
        console.log(e);
        if (e.response && e.response.status === 401) {
            EventBus.dispatch("logout");
        }
      });
  }

  handleShowEditExpenseModal = (expense) => {
    // Convert owner to username for editing
    const editingExpense = { ...expense };
    if (editingExpense.owner) {
      if (typeof editingExpense.owner === 'object' && editingExpense.owner.username) {
        // Owner is populated object
        editingExpense.owner = editingExpense.owner.username;
      } else if (typeof editingExpense.owner === 'string') {
        // Owner is ObjectId, find username
        const ownerMember = this.state.familyMembers.find(member => member.id === editingExpense.owner);
        editingExpense.owner = ownerMember ? ownerMember.username : editingExpense.owner;
      }
    }
    this.setState({ showEditExpenseModal: true, editingExpense, message: "" });
  }

  handleCloseEditModal = () => {
    this.setState({ showEditExpenseModal: false, editingExpense: null, message: "" });
  }

  handleEditExpenseChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState((prevState) => ({
      editingExpense: {
        ...prevState.editingExpense,
        [name]: type === "checkbox" ? checked : value,
      },
    }));
  }

  submitEditExpense = () => {
    const { editingExpense } = this.state;

    if (!editingExpense.name || !editingExpense.type || !editingExpense.owner || editingExpense.amount === "") {
      this.setState({ message: "Please fill in all mandatory fields." });
      return;
    }

    RecurringExpenseService.update(editingExpense._id, editingExpense)
      .then(() => {
        this.retrieveRecurringExpenses(this.state.selectedFamily.id);
        this.handleCloseEditModal();
      })
      .catch((e) => {
        this.setState({
          message:
            (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            "An error occurred while updating the expense.",
        });
      });
  }

  handleShowDeleteExpenseModal = (expense) => {
    this.setState({ showDeleteExpenseModal: true, deletingExpense: expense, message: "" });
  }

  handleCloseDeleteModal = () => {
    this.setState({ showDeleteExpenseModal: false, deletingExpense: null, message: "" });
  }

  submitDeleteExpense = () => {
    const { deletingExpense, selectedFamily } = this.state;
    FamilyService.removeRecurringExpenseFromFamily(selectedFamily.id, deletingExpense._id)
      .then(() => {
        this.retrieveRecurringExpenses(this.state.selectedFamily.id);
        this.handleCloseDeleteModal();
      })
      .catch((e) => {
        this.setState({
          message:
            (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            "An error occurred while deleting the expense.",
        });
      });
  }

  handleShowAddExpenseModal() {
    this.setState({ showAddExpenseModal: true, message: "" });
  }

  handleCloseModal() {
    this.setState({
      showAddExpenseModal: false,
      newExpense: { name: "", type: "basic", tr: false, amount: "", location: "", owner: "" },
      message: "",
    });
  }

  handleNewExpenseChange(e) {
    const { name, value, type, checked } = e.target;
    this.setState((prevState) => ({
      newExpense: {
        ...prevState.newExpense,
        [name]: type === "checkbox" ? checked : value,
      },
    }));
  }

  submitAddExpense() {
    const { selectedFamily, newExpense } = this.state;

    if (!newExpense.name || !newExpense.type || !newExpense.owner || newExpense.amount === "") {
      this.setState({ message: "Please fill in all mandatory fields." });
      return;
    }
    
    FamilyService.addRecurringExpenseToFamily(selectedFamily.id, newExpense)
      .then(() => {
        this.retrieveRecurringExpenses(selectedFamily.id);
        this.handleCloseModal();
      })
      .catch((e) => {
        this.setState({
          message:
            (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            "An error occurred while adding the expense.",
        });
      });
  }

  render() {
    const { recurringExpenses, selectedFamily, showAddExpenseModal, newExpense, message, familyMembers, showEditExpenseModal, editingExpense, showDeleteExpenseModal, deletingExpense } = this.state;

    const getOwnerUsername = (owner) => {
        if (typeof owner === 'object' && owner.username) {
            // Owner is populated object with username
            return owner.username;
        } else if (typeof owner === 'string') {
            // Owner is ObjectId string, find in family members
            const ownerMember = familyMembers.find(member => member.id === owner);
            return ownerMember ? ownerMember.username : 'N/A';
        }
        return 'N/A';
    };

    const columns = [
        { field: 'id', headerName: 'ID', width: 90 },
        { 
            field: 'name', 
            headerName: 'Name', 
            width: 150, 
            editable: true 
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 150,
            editable: true,
        },
        {
            field: 'owner',
            headerName: 'Owner',
            width: 150,
            editable: true,
        },
        {
            field: 'tr',
            headerName: 'TR',
            width: 150,
            editable: true,
        },
        {
            field: 'amount',
            headerName: 'Amount',
            width: 150,
            editable: true,
        },
        {
            field: 'location',
            headerName: 'Location',
            width: 150,
            editable: true,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 200,
            renderCell: (params) => {
                return (
                    <div>
                        <button className="btn btn-sm btn-info" onClick={() => this.handleShowEditExpenseModal(params.row)}>📝</button>
                        <button className="btn btn-sm btn-danger ml-2" onClick={() => this.handleShowDeleteExpenseModal(params.row)}>🗑️</button>
                    </div>
                );
            }
        }
      ];

    return (
      <div className="container">
        <header className="jumbotron">
          <h3>
            Recurring Expenses for Family: {selectedFamily ? selectedFamily.name : "None"}
          </h3>
        </header>
        <div className="mb-3">
            <button className="btn btn-success" onClick={this.handleShowAddExpenseModal}>
                Add Recurring Expense
            </button>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Owner</th>
              <th>TR</th>
              <th>Amount</th>
              <th>Location</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {recurringExpenses.length > 0 ? (
              recurringExpenses.map((expense, index) => (
                <tr key={index}>
                  <td>{expense.name}</td>
                  <td>{expense.type}</td>
                  <td>{getOwnerUsername(expense.owner)}</td>
                  <td>{expense.tr ? "Yes" : "No"}</td>
                  <td>{expense.amount}</td>
                  <td>{expense.location}</td>
                  <td>
                    <button className="btn btn-sm btn-info" onClick={() => this.handleShowEditExpenseModal(expense)}>📝</button>
                    <button className="btn btn-sm btn-danger ml-2" onClick={() => this.handleShowDeleteExpenseModal(expense)}>🗑️</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7">No recurring expenses for this family.</td>
              </tr>
            )}
          </tbody>
        </table>

        <RecurringExpenseModals
          showAddExpenseModal={showAddExpenseModal}
          handleCloseModal={this.handleCloseModal}
          message={message}
          newExpense={newExpense}
          handleNewExpenseChange={this.handleNewExpenseChange}
          submitAddExpense={this.submitAddExpense}
          familyMembers={familyMembers}
          showEditExpenseModal={showEditExpenseModal}
          handleCloseEditModal={this.handleCloseEditModal}
          editingExpense={editingExpense}
          handleEditExpenseChange={this.handleEditExpenseChange}
          submitEditExpense={this.submitEditExpense}
          showDeleteExpenseModal={showDeleteExpenseModal}
          handleCloseDeleteModal={this.handleCloseDeleteModal}
          deletingExpense={deletingExpense}
          submitDeleteExpense={this.submitDeleteExpense}
        />
      </div>
    );
  }
}
